module.exports = __webpack_public_path__ + "img/삼성카드.11ae2a16.png";